export function getEnumKeyValues(enumType: object) {
    return Object.entries(enumType).filter(([key]) => isNaN(Number(key)));
}
